<div [formGroup]="formGroup">
  <sc-checkbox-field formControlName="active" labelDictionaryKey="tmc-yard.entity.transport.masterdata.preloading"></sc-checkbox-field>
  @if (transport?.masterdata.preloading) {
    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
    <sc-date-time-field formControlName="date" [label]="'preloading time' | translate:['tmc-yard.entity.transport.masterdata.preloadingDate', translationService.language, translationService.revision]"></sc-date-time-field>
  }
</div>
